import React, { useContext } from 'react';
import { Form } from 'antd';
import moment from 'moment';

import { BookingContext } from '../../shared/contexts/Booking.context';
import FormItem from '../FormItem/FormItem';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';

export default function BookingSearchFormForm({ state, actions }) {
  const { state: bookingContextState } = useContext(BookingContext);
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { state: theme } = useContext(ThemeContext);
  return (
    <Form
      ref={actions.setFormInstance}
      scrollToFirstError={true}
      name="BookingSearchFormForm"
      onFinish={values => {
        const formattedValues = Object.keys(values).reduce((formattedValues, key) => {
          const field = bookingContextState.bookingSearchForm.fields.find(
            field => field.key == key
          );
          if (!field) return formattedValues;
          let value = values[key];
          if (field && field.type == 'date') value = moment(value).format('YYYY-MM-DD');
          if (value) formattedValues[key] = value;
          return formattedValues;
        }, {});
        actions.setBookingSearchFormValues(formattedValues);
      }}
      onValuesChange={(_, allValues) => {
        actions.setCurrentFormValues(allValues);
      }}
      onFinishFailed={onFinishFailed}
    >
      <div className={'form-title-container'}>
        <h1 className={'form-title'}>{theme.name}</h1>
        <h2 className={'form-subtitle'}>{translate('bookingSearchForm.title')}</h2>
      </div>

      {bookingContextState.bookingSearchForm?.fields
        ?.sort((field1, field2) => field1.position - field2.position)
        .map(field => (
          <FormItem
            field={field}
            key={field.key}
            currentValues={state.currentFormValues}
          ></FormItem>
        ))}

      <style jsx>
        {`
          .form-title-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .form-title,
          .form-subtitle {
            color: ${theme.titleColor};
            margin-bottom: 20px;
            text-align: center;
          }
          .form-subtitle {
            font-size: 18px;
            width: 60%;
            margin-bottom: 40px;
          }
        `}
      </style>
    </Form>
  );
}

const onFinishFailed = errorInfo => {
  console.log('Failed:', errorInfo);
};
